import { createSlice } from '@reduxjs/toolkit';

import { AUTH } from '@app/store/constants/constants';
import { AUTH_INITIAL_STATE } from '@app/store/reducers/authReducer/auth.state';
import type { NAccessRights } from '@app/types';
import type { NAuth } from '@app/types/Auth';

import type { PayloadAction } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: AUTH,
  initialState: AUTH_INITIAL_STATE,
  reducers: {
    setAuthReset: () => AUTH_INITIAL_STATE,
    setUser: (state, { payload }: PayloadAction<NAuth.User>) => {
      state.user = payload;
    },
    setAccessRights: (
      state,
      { payload }: PayloadAction<NAccessRights.ModelAccessRights>
    ) => {
      state.accessRights = payload;
    },
    setActiveBranchName: (
      state,
      { payload }: PayloadAction<NAuth.AuthInitialState['activeBranchName']>
    ) => {
      state.activeBranchName = payload;
    },
    setActiveBranchCountryId: (state, { payload }: PayloadAction<number>) => {
      state.activeBranchCountryId = payload;
    },
    setOrganizations: (
      state,
      { payload }: PayloadAction<NAuth.ModelOrganizationAuth[] | null>
    ) => {
      state.organizations = payload ?? [];
    },
  },
});

export const {
  setAuthReset,
  setUser,
  setAccessRights,
  setActiveBranchName,
  setActiveBranchCountryId,
  setOrganizations,
} = authSlice.actions;
export const authReducer = authSlice.reducer;
